var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_c('div',{staticClass:"bg-dt"},[_c('div',{staticClass:"d-flex jc-center"},[_c('CenterLeft2Chart')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }